import React from 'react';
import energyboxLogoWhite from './logos/energybox_logo-white.svg';

const SiteFooter = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <footer className="app__footer">
      <img
        className="app__footer-logo"
        src={energyboxLogoWhite}
        alt="Energybox"
      />
    </footer>
  );
};

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/SiteFooter.js